module.exports = __webpack_public_path__ + "img/individual-bars.c3f7471.svg";